import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/app/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import SearchFilterCard from "../../components/general/filter-card";
import Can from "../../utils/rbac/can";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import BannerCategoryFilter from "../../components/banner-campaigns-screen/banner-filter";
import BannerCategoryTable from "../../components/banner-campaigns-screen/banner-table";
import BannerCategoryContextProvider from "../../context/banner-campaigns-screen/provider";
import BannerCategoryContext from "../../context/banner-campaigns-screen/context";
interface IProps {
  children?: React.ReactNode;
}
// sum array in js
const BannerCategory: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(BannerCategoryContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {

    !isMounted && actions.getData(1);
  }, [query, direction]);
  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("banners")}
        subTitle={t("banners_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData(1)}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
            <Button
              type="primary"
              onClick={() => {
                navigate(`/banners-campaigns-screen/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_banner")}
            </Button>
          </Can>,
        ]}
      />
      <SearchFilterCard
        formId="campaign-screen-banner-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        <BannerCategoryFilter />
      </SearchFilterCard>
      <BannerCategoryTable />
    </div>
  );
};

const BannerCampaignScreenPage = () => {
  return (
    // ContextProvider
    <BannerCategoryContextProvider>
      <BannerCategory />
    </BannerCategoryContextProvider>
  );
};
export default BannerCampaignScreenPage;